export function removeEmptyElements(html: string): string {
  let previous: string;
  do {
    previous = html;
    html = html.replace(/<([a-zA-Z0-9]+)(\s[^>]*)?>\s*<\/\1>/g, '');
  } while (html !== previous); // Keep cleaning until no further replacements

  return html;
}

export const parseHtmlContent = (htmlString: string) => {
  if (!htmlString || htmlString?.length === 0) return null;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  const titleElement = tempDiv.querySelector('h1');
  const title = titleElement ? titleElement.textContent : '';

  const descriptionElement = tempDiv.querySelector('p');
  const description = descriptionElement ? descriptionElement.textContent : '';

  return {
    title,
    description
  };
}